import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FilteredGroups } from 'src/AngularJS/Reusables/group-selector.models';
import { GroupSelectorService } from 'src/app/reusables/group-selector/group-selector.service';

@Component({
    selector: 'cv-ag-grid-group-header-tooltip',
    templateUrl: './ag-grid-group-header-tooltip.component.html',
    styleUrls: ['./ag-grid-group-header-tooltip.component.scss'],
})
export class AgGridGroupHeaderTooltipComponent implements ITooltipAngularComp {
    public isHeader: boolean;
    public params: ITooltipParams;
    public selectedParents: Array<string> = null;
    public allGroups: {[level: number]: FilteredGroups} = null;
    public parentGroupLevel: number;
    public maxLevel: number;
    public show = false;

    constructor(
        private cdr: ChangeDetectorRef,
        public groupService: GroupSelectorService,
    ) {}

    async loadGroups(moduleKey, baseGroupType, level) {
        this.allGroups = (await this.groupService.loadFilteredGroups(moduleKey, baseGroupType, level)).data;
    }

    async agInit(params: ITooltipParams) {
        this.isHeader = params.location === 'header';
        this.params = params;
        if (!this.isHeader) {
            params.value = params.value.replaceAll("&gt;", ">");
        }
        else {
            this.parentGroupLevel = params.context.moduleManager.moduleSettings.selectedGroupLevel + 1;
            const selectedGroupType = params.context.moduleManager.moduleSettings.selectedGroupType;
            this.maxLevel = params.context.moduleManager.moduleSettings.maxGroupLevel;
            await this.loadGroups(params.context.moduleManager.container.moduleKey,
                selectedGroupType,
                this.parentGroupLevel);

            const selectedGroups = selectedGroupType === 0 ?
                params.context.moduleManager.moduleSettings.empSelectorDTO : params.context.moduleManager.moduleSettings.recSelectorDTO;
            let selectedParentsIDs;
            switch (this.parentGroupLevel) {
                case 2:
                    selectedParentsIDs = selectedGroups._SelectedGroup2IDList;
                    this.ifAllSelected(this.parentGroupLevel, selectedParentsIDs);
                    this.notAllSelected(this.parentGroupLevel, selectedParentsIDs);
                    break;
                case 3:
                    selectedParentsIDs = selectedGroups._SelectedGroup3IDList;
                    this.ifAllSelected(this.parentGroupLevel, selectedParentsIDs);
                    this.notAllSelected(this.parentGroupLevel, selectedParentsIDs);
                    break;
                case 4:
                    selectedParentsIDs = selectedGroups._SelectedGroup4IDList;
                    this.ifAllSelected(this.parentGroupLevel, selectedParentsIDs);
                    this.notAllSelected(this.parentGroupLevel, selectedParentsIDs);
                    break;
                case 5:
                    selectedParentsIDs = selectedGroups._SelectedGroup5IDList;
                    this.ifAllSelected(this.parentGroupLevel, selectedParentsIDs);
                    this.notAllSelected(this.parentGroupLevel, selectedParentsIDs);
                    break;
            }
        }
    }
    notAllSelected(parentGroupLevel, selectedParentIDs) {
        if (selectedParentIDs[0] !== 0) {
            this.selectedParents = selectedParentIDs.map(
                id => this.allGroups[parentGroupLevel]?.Groups.find(group => id === group.GroupID)?.GroupName
            );
            this.cdr.detectChanges();
        }
    }

    ifAllSelected(parentGroupLevel, selectedParentIDs) {
        if (selectedParentIDs[0] === 0) {
            this.selectedParents = this.allGroups[parentGroupLevel]?.Groups.map(each => (each.GroupName));
            this.cdr.detectChanges();
        }
    }

    showTooltip() {
        this.show = true;
    }

    hideTooltip() {
        this.show = false;
    }
}
